import { useRef, useState } from 'react';

const TOOLTIP_TIMEOUT = 2000;

export const useTooltip = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);
  const productRef = useRef<HTMLDivElement | null>(null);

  const handleToggleTooltip = (
    e: React.MouseEvent<HTMLDivElement>,
    hasTooltip: boolean,
    itemClassName: string,
  ) => {
    if (!hasTooltip || !productRef.current) return;

    e.stopPropagation();
    const itemContainer = productRef.current.closest(
      `.${itemClassName}`,
    ) as HTMLElement | null;

    if (showTooltip) {
      productRef.current.removeAttribute('style');
    } else {
      if (itemContainer) itemContainer.style.zIndex = '100';
      if (timeoutId) clearTimeout(timeoutId);

      const timeout = setTimeout(() => {
        setShowTooltip(false);
        if (itemContainer) itemContainer.style.zIndex = '0';
      }, TOOLTIP_TIMEOUT);

      setTimeoutId(timeout);
    }

    setShowTooltip(!showTooltip);
  };

  return {
    showTooltip,
    setShowTooltip,
    productRef,
    handleToggleTooltip,
  };
};
